class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);

    // Auto close after 5 seconds
    setTimeout(() => {
      this.close();
    }, 2500); // 5000ms = 5 seconds
    
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    // Pre-compute all HTML updates before touching DOM
    const updates = [];
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      if (sectionElement && parsedState.sections[section.id]) {
        updates.push([sectionElement, this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)]);
      }
    });

    // Batch all DOM writes in a single rAF for better INP
    requestAnimationFrame(() => {
      for (const [el, html] of updates) el.innerHTML = html;
      if (this.header) this.header.reveal();
      this.updateCartDrawer(parsedState);
      this.open();
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-drawer', // Ensure cart drawer updates
        selector: '.cart-drawer-content',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  updateCartDrawer(parsedState) {
    const empCart = document.querySelector('cart-drawer');
    if (empCart && empCart.classList.contains('is-empty')) {
      empCart.classList.remove('is-empty');
      const cartDrawer = document.getElementById('CartDrawer');
      if (cartDrawer) {
        cartDrawer.innerHTML = this.getSectionInnerHTML(parsedState.sections['cart-drawer'], '.cart-drawer');
      }
      // console.log('One Qty Add');
    }
    
  }
}

customElements.define('cart-notification', CartNotification);
